import React from 'react';
import { motion } from 'framer-motion';

interface StaggeredWordsProps {
  text: string;
  className?: string;
  delay?: number;
  staggerDelay?: number;
  animationType?: 'fadeUp' | 'fadeIn' | 'slideIn' | 'bounce';
}

const StaggeredWords: React.FC<StaggeredWordsProps> = ({
  text,
  className = '',
  delay = 0,
  staggerDelay = 0.1,
  animationType = 'fadeUp'
}) => {
  const words = text.split(' ');

  const getAnimationVariants = () => {
    switch (animationType) {
      case 'fadeIn':
        return {
          hidden: { opacity: 0 },
          visible: { opacity: 1 }
        };
      case 'slideIn':
        return {
          hidden: { opacity: 0, x: -20 },
          visible: { opacity: 1, x: 0 }
        };
      case 'bounce':
        return {
          hidden: { opacity: 0, y: 20, scale: 0.8 },
          visible: { 
            opacity: 1, 
            y: 0, 
            scale: 1,
            transition: {
              type: "spring",
              stiffness: 500,
              damping: 25
            }
          }
        };
      default: // fadeUp
        return {
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0 }
        };
    }
  };

  const variants = getAnimationVariants();

  return (
    <motion.div
      className={className}
      initial="hidden"
      animate="visible"
      transition={{ delay, staggerChildren: staggerDelay }}
    >
      {words.map((word, index) => (
        <motion.span
          key={index}
          variants={variants}
          className="inline-block mr-2"
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {word}
        </motion.span>
      ))}
    </motion.div>
  );
};

export default StaggeredWords;